import similaryProduct from "./similaryProduct"
export default similaryProduct;
